export const OtherExpensesInfo = {
  TITLE: 'Other Expenses',
  KEY: 'otherExpenses',
  PENDING_CHANGES_KEY: 'applicationPropertyOtherExpenses',
  PENDING_CHANGES_NAME: 'otherExpensesPendingChanges',
};

export const TableColumnId = {
  NAME: 'name',
  VALUE: 'value',
};

export const defaultSortOrder = {
  direction: 'desc',
  id: TableColumnId.NAME,
};
